/**
 * Every page tour, by page key. A tour is { title, steps(ctx) => Step[] } where
 * ctx = { user, access (settingsAccess), isPlatform, companyName, demoMode, variant }.
 * Steps whose `when(ctx)` is false are dropped; steps whose target is not on the
 * page (a role without that button, an empty list) are skipped at run time.
 */
import dashboard from './pages/dashboard';
import submissions from './pages/submissions';
import payments from './pages/payments';
import performance from './pages/performance';
import settings from './pages/settings';
import regions from './pages/regions';
import ownerConsole from './pages/ownerConsole';
import setupWizard from './pages/setupWizard';
import help from './pages/help';

const TOURS = {
  dashboard,
  submissions,
  payments,
  performance,
  settings,
  regions,
  'owner-console': ownerConsole,
  'setup-wizard': setupWizard,
  help
};

export const getTour = (key) => TOURS[key] || null;
export const tourKeys = () => Object.keys(TOURS);
export default TOURS;
